"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var Tabs = __importStar(require("./Tabs"));
var prop_types_1 = __importDefault(require("prop-types"));
function Form(_a) {
    var channel = _a.channel, setChannel = _a.setChannel, submit = _a.submit, user = _a.user, type = _a.type;
    var tabItems = [
        {
            name: 'Channel',
            label: type.label,
            save: true,
        },
    ];
    if (user.is_admin) {
        tabItems.push({
            name: 'Options',
            label: 'Options',
            save: true,
            admin: true,
        });
        tabItems.push({
            name: 'Media',
            label: 'Media',
            save: true,
            admin: true,
        });
    }
    if (channel.data.id && (['player', 'competition'].includes(channel.data.type) || user.is_admin)) {
        tabItems.push({
            name: 'Teams',
            label: 'teams',
            save: false,
        });
    }
    var _b = react_1.useState(tabItems[0]), activeTab = _b[0], setActiveTab = _b[1];
    var ActiveTab = Tabs[activeTab.name];
    return react_1.default.createElement(storybook_1.Cards.Card, null,
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement(storybook_1.Menus.Dashboard.Tabs, { activeTab: activeTab.name, setActiveTab: function (name) { return setActiveTab(tabItems.findBy('name', name)); }, items: tabItems, user: user }),
            react_1.default.createElement(ActiveTab, { type: type, channel: channel, setChannel: setChannel, user: user, submit: submit }),
            activeTab.save && react_1.default.createElement(storybook_1.Forms.Buttons, { errors: channel.errors, loading: channel.submitting, submit: submit, title: 'Opslaan' })));
}
exports.default = Form;
Form.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
};
